
import { Component, Prop } from "vue-property-decorator";
import { PageBase } from "@/core/models/shared";

@Component
export default class RelatorioPage extends PageBase {
    @Prop() private titulo!: string;
    @Prop({ default: true }) private fonteVariavel!: boolean;
    @Prop() private paisagem!: boolean;
    @Prop() private exportarExcel!: boolean;
    @Prop({ default: 100 }) private fonteInicial!: number;
    @Prop({ default: true }) private cabecalhoCompleto!: boolean;
    @Prop({ default: false }) private semMargens!: boolean;

    root: any = document.documentElement;
    isEmpresa: boolean = false;

    mounted() {
        this.root = document.body;

        if (this.paisagem) {
            this.root.style.setProperty("--widthPage", 29.7 + "cm");
            this.root.style.setProperty("--min-heightPage", 19 + "cm");
            this.setPageSize("landscape");
        } else {
            this.root.style.setProperty("--widthPage", 21 + "cm");
            this.root.style.setProperty("--min-heightPage", 26 + "cm");
            this.setPageSize("portrait");
        }

        document.documentElement.style.setProperty("--fontSize", this.fonteInicial + "%");
    }

    setPageSize(size: string) {
        const style = document.createElement("style");
        const margin = this.semMargens ? "; margin: 0" : "";
        style.innerHTML = `@page {size: ${size}${margin}}`;
        document.head.appendChild(style);
    }

    AumentarFonte() {
        const raiz = getComputedStyle(this.root);
        let valor = parseFloat(raiz.getPropertyValue("--fontSize").replace("%", ""));
        valor += 5;
        document.documentElement.style.setProperty("--fontSize", valor + "%");
    }

    DiminuirFonte() {
        const raiz = getComputedStyle(this.root);
        let valor = parseFloat(raiz.getPropertyValue("--fontSize").replace("%", ""));
        valor -= 5;
        document.documentElement.style.setProperty("--fontSize", valor + "%");
    }

    Imprimir() {
        window.print();
    }

    Fechar() {
        window.close();
    }
}
